import React from "react";
import { Link as ScrollLink } from "react-scroll";

const aboutData = {
  cvpath: "media/mehdisaleh.pdf",
  image: "images/about.png",
  name: "Mahdi Saleh",
  location: "Alborz, IR",
  birthday: "02 August, 1997",
  email: "mahdiksaleh@gmail.com",

};

function About() {
  return (
    <div className="row">
      <div className="col-md-3">
        <img src={aboutData.image} alt={aboutData.name} />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Hello,</h2>
        <p className="mb-0">I am Mehdi Saleh, born in 1997 and a graduate in Accounting. My career began in mobile sales, which later led to my interest in IT as a System Administrator at a company producing VPNs and Apple IDs. I expanded my skills as a WordPress Administrator in the IT team of an internet services company (Idigi).

After completing military service, I pursued professional training in Linux, networking, and DevOps tools such as Grafana, Prometheus, Kubernetes, Docker, Git, ESXi, Elasticsearch, Kibana, and CI/CD pipelines. I have hands-on experience with these technologies in both projects and documentation. Currently, I am eager to start my journey as a DevOps Engineer, leveraging my skills and passion for continuous improvemen</p>
        <div className="row my-4">
          <div className="col-md-6">
            <p className="mb-2">
              Name: <span className="text-dark">{aboutData.name}</span>
            </p>
            <p className="mb-0">
              Birthday: <span className="text-dark">{aboutData.birthday}</span>
            </p>
          </div>
          <div className="col-md-6 mt-2 mt-md-0 mt-sm-2">
            <p className="mb-2">
              Location: <span className="text-dark">{aboutData.location}</span>
            </p>
            <p className="mb-0">
              Email: <span className="text-dark">{aboutData.email}</span>
            </p>
          </div>
        </div>
        <a href={aboutData.cvpath} className="btn btn-default mr-3">
          <i className="icon-cloud-download"></i>Download CV
        </a>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-2 mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
